import React from "react";

const AgencyPitchesMobileFilters = ({
  onAgentFilterClick,
  onPositionFilterClick,
  agentFilterText,
  positionFilterText,
}) => {
  return (
    <div className="px-4 py-3 bg-white flex flex-wrap gap-2 items-center border-b border-[#0000001A]">
      <button
        onClick={onAgentFilterClick}
        className="border border-[#D2D4D8] rounded-lg px-3 py-1.5 text-xs font-medium bg-white hover:bg-gray-50 flex-1 text-center"
      >
        {agentFilterText}
      </button>
      <button
        onClick={onPositionFilterClick}
        className="border border-[#D2D4D8] rounded-lg px-3 py-1.5 text-xs font-medium bg-white hover:bg-gray-50 flex-1 text-center"
      >
        {positionFilterText}
      </button>
    </div>
  );
};

export default AgencyPitchesMobileFilters;